<div class="edit-page-root-container employee-edit-root-container">
  <div class="page-content">
    <div class="page-header">
      <button mat-button class="nav-button" (click)="navBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        @if(permission.can_edit){
        <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
        <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
        }
      </div>
    </div>

    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <mat-tab-group animationDuration="0ms" style="width:100%;">
              <mat-tab label="Employee Details">
                <div class="employee-details-grid" style="padding-top: 20px;">
                  <mat-form-field class="employee-field code-field">
                    <mat-label>Code</mat-label>
                    <input matInput formControlName="code" maxlength="50" appCodeInput>
                    <mat-error *ngIf="editForm.get('code')?.hasError('required') && editForm.get('code')?.touched">
                      Code is required.
                    </mat-error>
                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                      10.</mat-error>
                  </mat-form-field>
                  <mat-form-field class="employee-field fname-field">
                    <mat-label>First Name</mat-label>
                    <input matInput formControlName="f_name">
                    <mat-error *ngIf="editForm.get('f_name')?.hasError('required') && editForm.get('f_name')?.touched">
                      First Name is required.
                    </mat-error>
                    <mat-error *ngIf="editForm.controls['f_name'].hasError('maxlength')">Maximum length is
                      50.</mat-error>
                  </mat-form-field>

                  <mat-form-field class="employee-field">
                    <mat-label>Middle Name</mat-label>
                    <input matInput formControlName="m_name">
                  </mat-form-field>
                  <mat-form-field class="employee-field">
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName="l_name">
                  </mat-form-field>

                  <div class="employee-field gender-field">
                    <mat-label>Gender</mat-label>
                    <mat-radio-group formControlName="sex">
                      <mat-radio-button value="M">Male</mat-radio-button>
                      <mat-radio-button value="F">Female</mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <mat-form-field class="employee-field">
                    <mat-label>Date Of Birth</mat-label>
                    <input matInput [matDatepicker]="dobPicker" formControlName="dob">
                    <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dobPicker></mat-datepicker>
                    <mat-error *ngIf="editForm.get('dob')?.hasError('required') && editForm.get('dob')?.touched">
                      Date of Birth is required.
                    </mat-error>
                    <mat-error *ngIf="editForm.get('dob')?.hasError('futureDate') && editForm.get('dob')?.touched">
                      Date of Birth cannot be in the future.
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="employee-field">
                    <mat-label>Date Of Joining</mat-label>
                    <input matInput [matDatepicker]="dojPicker" formControlName="doj">
                    <mat-datepicker-toggle matSuffix [for]="dojPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dojPicker></mat-datepicker>
                    <mat-error *ngIf="editForm.get('doj')?.hasError('futureDate') && editForm.get('doj')?.touched">
                      Date of Joining cannot be in the future.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="employee-field">
                    <mat-label>Category</mat-label>
                    <mat-select placeholder="Category" formControlName="employee_category_id">
                      @for (cat of categoryList; track cat.id) {
                      <mat-option [value]="cat.id">
                        {{ cat.name }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="employee-field">
                    <mat-label>Department</mat-label>
                    <mat-select formControlName="department_id">
                      <mat-option *ngFor="let dept of departmentList" [value]="dept.id">{{dept.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="employee-field">
                    <mat-label>Permit Number</mat-label>
                    <input matInput formControlName="work_permit">
                  </mat-form-field>
                  <mat-form-field class="employee-field">
                    <mat-label>Card Number</mat-label>
                    <input matInput formControlName="card_no">
                    <mat-error
                      *ngIf="editForm.get('card_no')?.hasError('required') && editForm.get('card_no')?.touched">
                      Card Number is required.
                    </mat-error>
                  </mat-form-field>

                  <!-- Cost per Hour -->
                  <mat-form-field class="employee-field">
                    <mat-label>Cost per Hour</mat-label>
                    <input matInput type="number" formControlName="cost_per_hour">
                    <mat-error
                      *ngIf="editForm.get('cost_per_hour')?.hasError('required') && editForm.get('cost_per_hour')?.touched">
                      Cost per Hour is required.
                    </mat-error>
                    <mat-error
                      *ngIf="editForm.get('cost_per_hour')?.hasError('negative') && editForm.get('cost_per_hour')?.touched">
                      Value cannot be negative.
                    </mat-error>
                  </mat-form-field>

                  <!-- Over Time Pay Rate -->
                  <mat-form-field class="employee-field">
                    <mat-label>Over Time Pay Rate</mat-label>
                    <input matInput type="number" formControlName="over_time_pay_rate">
                    <mat-error
                      *ngIf="editForm.get('over_time_pay_rate')?.hasError('negative') && editForm.get('over_time_pay_rate')?.touched">
                      Value cannot be negative.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="employee-field  ">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="status">
                      <mat-option value="1">Active</mat-option>
                      <mat-option value="2">Resigned</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="employee-field ">
                    <mat-label>Wage Type</mat-label>
                    <mat-select formControlName="wage_type">
                      <mat-option value="1">Hourly</mat-option>
                      <mat-option value="2">Daily</mat-option>
                      <mat-option value="3">Weekly</mat-option>
                      <mat-option value="4">Monthly</mat-option>

                    </mat-select>
                    <mat-error
                      *ngIf="editForm.get('wage_type')?.hasError('required') && editForm.get('wage_type')?.touched">
                      Wage Type is required.
                    </mat-error>
                  </mat-form-field>
                </div>
              </mat-tab>
              <mat-tab label="Address Details">
                <div class="personnel-details-section">
                  <div class="address-section">
                    <div class="address-title">Permanent Address</div>
                    <div class="address-fields">
                      <mat-form-field class="address-field full-width">
                        <mat-label>Address</mat-label>
                        <textarea matInput formControlName="address"></textarea>
                      </mat-form-field>
                      <mat-form-field class="address-field">
                        <mat-label>Country</mat-label>
                        <input matInput formControlName="country">
                      </mat-form-field>
                      <mat-form-field class="address-field">
                        <mat-label>Zip Code</mat-label>
                        <input matInput formControlName="zip_code">
                      </mat-form-field>
                      <mat-form-field class="address-field">
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="phone">
                        <mat-error *ngIf="editForm.get('phone')?.hasError('pattern') && editForm.get('phone')?.touched">
                          Please enter a valid phone number (digits only).
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="address-field">
                        <mat-label>Fax</mat-label>
                        <input matInput formControlName="fax">
                      </mat-form-field>
                      <mat-form-field class="address-field full-width">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email">
                        <mat-error *ngIf="editForm.get('email')?.hasError('email') && editForm.get('email')?.touched">
                          Please enter a valid email address.
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="address-section">
                    <div class="address-title">Present Address Details</div>
                    <mat-checkbox [checked]="sameAsAbove" (change)="onSameAsAboveChange($event.checked)">Same as
                      above</mat-checkbox>

                    <div class="address-fields">
                      <mat-form-field class="address-field full-width">
                        <mat-label>Present Address</mat-label>
                        <textarea matInput formControlName="loc_address"></textarea>
                      </mat-form-field>
                      <mat-form-field class="address-field">
                        <mat-label>Country</mat-label>
                        <input matInput formControlName="loc_country">
                      </mat-form-field>
                      <mat-form-field class="address-field">
                        <mat-label>Zip Code</mat-label>
                        <input matInput formControlName="loc_zip_code">
                      </mat-form-field>
                      <mat-form-field class="address-field">
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="loc_phone">
                        <mat-error
                          *ngIf="editForm.get('loc_phone')?.hasError('pattern') && editForm.get('loc_phone')?.touched">
                          Please enter a valid phone number (digits only).
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="address-field">
                        <mat-label>Fax</mat-label>
                        <input matInput formControlName="loc_fax">
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Payroll Details" *ngIf="employeeInfo.id !== 0 && employeeInfo.id !== undefined">

                <div class="payroll-details-section"
                  style="padding-top: 20px; display: flex; align-items: center; gap: 20px;">
                  <div class="input-box-end">
                    <mat-form-field class="payroll-code">
                      <mat-label>Payroll Code</mat-label>
                      <input matInput formControlName="payroll_code">
                      <mat-error *ngIf="editForm.controls['payroll_code'].hasError('required')">
                        Payroll Code is required
                      </mat-error>
                      <mat-error
                        *ngIf="editForm.controls['payroll_code'].hasError('minlength') || editForm.controls['payroll_code'].hasError('maxlength')">
                        must be exactly 7 characters long
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="payroll-field">
                    <mat-checkbox formControlName="can_export">Fixed Pay</mat-checkbox>
                  </div>

                </div>
              </mat-tab>




            </mat-tab-group>



          </div>
        </div>







      </form>
    </div>
  </div>
</div>